import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { NoVisaInformationCB } from './NoVisaInformationCB';

export default defineComponent({
	setup: () => {
		const codeBehind = new NoVisaInformationCB();

		return setupComponent(codeBehind);
	},
});
